import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["imgSrc", "showAIBadge"];
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Image } from 'foundations-components/transitional/components/Image';
import { View } from 'foundations-components/transitional/components/View';
import { InsertImageIcon } from 'foundations-assets/icons/components/InsertImageIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AssetThumbnail = _ref => {
  let {
      imgSrc,
      showAIBadge
    } = _ref,
    styleProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Flex, Object.assign({
    position: "relative",
    backgroundColor: "fill-tertiary-pressed",
    overflow: "hidden",
    alignItems: "center",
    justifyContent: "center"
  }, styleProps, {
    children: /*#__PURE__*/_jsxs(Box, {
      overflow: "hidden",
      blockSize: "100%",
      display: "flex",
      alignItems: "center",
      children: [imgSrc ? /*#__PURE__*/_jsx(Image, {
        src: imgSrc,
        blockSize: "100%",
        objectFit: "contain",
        "data-test-id": "asset-thumbnail"
      }) : /*#__PURE__*/_jsx(IconHolder, {
        icon: InsertImageIcon,
        justifyContent: "center",
        alignItems: "center",
        blockSize: "100%",
        inlineSize: "100%",
        color: "icon-interactive-default",
        size: "700",
        "data-test-id": "thumbnail-fallback"
      }), showAIBadge && /*#__PURE__*/_jsx(View, {
        position: "absolute",
        insetBlockStart: "0",
        insetInlineEnd: "0",
        paddingInline: "200",
        children: /*#__PURE__*/_jsx(AIBadge, {})
      })]
    })
  }));
};
export default AssetThumbnail;